import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { PageProps } from '@/types/PageProps';
import SettingsCompanyPurchase from '@/components/Companies/Settings/CompanyPurchase';

export default function CompanyPurchasesPage({ route }: PageProps) {
  const intl = useIntl();

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <div className="page">
        <SettingsCompanyPurchase />
      </div>
    </>
  );
}
